export default __webpack_public_path__ + "static/media/will_qanon.0c1da166.jpg";